import React from 'react';
import { useTranslation } from 'react-i18next';

import content from '../../../assets/images/content.svg';
import lockIcon from '../../../assets/images/LockedReward.png';

import styles from './SmartRewardPill.module.scss';

/**
 * SmartRewardPill — compact reward indicator for job list cards.
 * Uses the `reward_visibility` object from the API.
 *
 * Visibility modes:
 *  - "full"          → shows exact amount (green pill, same as MonetaryRewardsPill)
 *  - "starting_from" → shows "Starting from $X" (green pill with prefix)
 *  - "up_to"         → shows "Up to $X" (muted pill with lock icon)
 *  - "not_eligible"  → shows "Up to $X" (muted pill with lock icon)
 *  - "none"          → nothing rendered
 */
const SmartRewardPill = ({ rewardVisibility }) => {
  const { t } = useTranslation('common');

  if (!rewardVisibility || rewardVisibility.visibility === 'none') {
    return null;
  }

  const { visibility, display_label } = rewardVisibility;

  if (visibility === 'up_to' || visibility === 'not_eligible') {
    return (
      <div className={styles.lockedContainer}>
        <div className={styles.lockIconContainer}>
          <img className={styles.lockIcon} src={lockIcon} alt={t('rewards.locked')} />
        </div>
        <span className={styles.lockedText}>{display_label}</span>
      </div>
    );
  }

  // "full" or "starting_from" — green pill
  return (
    <div className={styles.mainContainer}>
      <div className={styles.iconContainer}>
        <img className={styles.iconStyles} src={content} alt="reward" />
      </div>
      <div className={styles.textContainer}>{display_label}</div>
    </div>
  );
};

export default SmartRewardPill;
